import type { ComputedRef, InjectionKey, Ref } from 'vue';
import type { InputStatusState } from '../internal';

export type NxRadioItemBaseProps<T extends string | number> = {
  value: T;
  disabled?: boolean;
  label?: string;
};

/** An item's self-registration with its group, used for roving-tabindex focus. */
export type NxRadioItemRegistration = {
  value: string | number;
  /** Reactive disabled state getter (item or group disabled). */
  disabled: () => boolean;
  /** Move DOM focus to this item's input. */
  focus: () => void;
};

export const nxRadioGroupInjectionKey = Symbol() as InjectionKey<{
  modelValue: Ref<string | number>;
  name: Ref<string | undefined>;
  disabled: Ref<boolean>;
  /** The single item that is part of the tab sequence (checked, else first enabled). */
  activeValue: ComputedRef<string | number | null>;
  /** Select an item (Space/Enter/click). No-op for disabled items/groups. */
  select: (value: string | number) => void;
  /** Register an item for roving-tabindex navigation; returns an unregister fn. */
  register: (registration: NxRadioItemRegistration) => () => void;
  /** Current save status of the group (from NxLoadingWrapper), for the selected item's badge. */
  saveState: ComputedRef<InputStatusState>;
  /** Error message from the wrapper, for the error tooltip on the selected item's badge. */
  errorMessage: ComputedRef<string | undefined>;
  /** True while the success badge fades before the wrapper returns to idle. */
  saveFadeOut: ComputedRef<boolean>;
}>;
